import { en } from '../assets/labels-en';

const Banner = ({
  bannerImage,
  header = 'Claim Your Property',
  showPropertyAmount = false,
  amount = 0,
}) => {
  return (
    <div className="app-banner">
      <div className="banner-content">
        <h1>{header}</h1>
        <div className="banner-image-container">
          {bannerImage && (
            <img src={bannerImage} alt="Banner" className="img-fluid" />
          )}
          {showPropertyAmount && (
            <div className="property-amount-card">
              <p className="property-amount-label">
                {en.property_amount_label}:
              </p>
              <p className="property-amount-value">
                {amount !== 'NA' ? `USD $${amount}` : amount}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
